/* eslint-disable max-lines-per-function */
/* eslint-disable react/jsx-no-bind */
import {
    AutocompleteInput,
    NumberInput,
    ReferenceField,
    ReferenceInput,
    TabbedForm,
    TextField,
    TextInput,
    useTranslate
} from "react-admin";

import { useInputStyles } from "../../../utils/useInputStyles";

import { TitleTextField } from "../../../common/TitleTextField";
import { CreateToolbar } from "../../../common/CreateToolbar";
import { EditToolbar } from "../../../common/EditToolbar";
import { ImageListInput } from "../../image/components/Form";
import { PublicationFormGroup } from "../../../utils/components/form/PublicationFormGroup";

export function SeasonSimpleFormContent(): JSX.Element {
    const classes = useInputStyles;
    const isCreateMode: boolean = window.location.href.includes("/create");
    const t = useTranslate();
    const formProps: any = {};

    if (isCreateMode) {
        formProps["toolbar"] = <CreateToolbar />;
    } else {
        // Edit
        formProps["toolbar"] = <EditToolbar />;
    }

    return (
        <TabbedForm {...formProps}>
            <TabbedForm.Tab label="general">
                <TitleTextField type={isCreateMode ? "create" : "edit"} />
                <ReferenceInput source="serie.id" reference="serie">
                    <AutocompleteInput optionValue="id" optionText="name" fullWidth />
                </ReferenceInput>
                <ReferenceField source="serie.id" reference="serie" label={t("resources.season.fields.serie")}>
                    <TextField source="name" />
                </ReferenceField>
                <NumberInput source="position" min={1} />
                <TextInput sx={classes.inputField} source="name" />
                <TextInput sx={classes.inputField} source="description" fullWidth multiline />
                <ImageListInput targetType="season" />
            </TabbedForm.Tab>
            <TabbedForm.Tab label="publication">
                <PublicationFormGroup />
            </TabbedForm.Tab>
        </TabbedForm>
    );
}
